/* eslint camelcase: "off" */
import React from "react";
import { Stack, Text } from "@mantine/core";
import dayjs from "dayjs";

interface AuditTimestampsProps {
  created_at?: string | null;
  created_by_name?: string | null;
  updated_at?: string | null;
  updated_by_name?: string | null;
}

const AuditTimestamps: React.FC<AuditTimestampsProps> = ({
  created_at,
  created_by_name,
  updated_at,
  updated_by_name,
}) => {
  if (!created_at && !updated_at) return null;

  const isUpdated =
    updated_at &&
    dayjs(updated_at).valueOf() !== dayjs(created_at).valueOf();

  return (
    <Stack spacing={2}>
      {created_at && (
        <Text size="xs" color="dimmed">
          Created: {dayjs(created_at).format("DD MMM YYYY HH:mm")}
          {created_by_name && ` by ${created_by_name}`}
        </Text>
      )}
      {isUpdated && (
        <Text size="xs" color="dimmed">
          Updated: {dayjs(updated_at).format("DD MMM YYYY HH:mm")}
          {updated_by_name && ` by ${updated_by_name}`}
        </Text>
      )}
    </Stack>
  );
};

export default AuditTimestamps;
